import { S3ClientService } from '../../tools/helpers';

export const getEmployeeImageQueryConfig = <TSelectData = string,>({
  imageUrl,
  select,
}: {
  imageUrl: string;
  select?: (data: string) => TSelectData;
}) => ({
  queryFn: () => {
    return S3ClientService.getFileS3BucketUrl(imageUrl, 'kalos-employee-images');
  },
  queryKey: ['employeeImage', imageUrl],
  // A signed link lasts 90 minutes on the server; many avatars mount at once, so it is not re-signed on every focus.
  staleTime: 30 * 60 * 1000,
  refetchOnWindowFocus: false,
  select,
});
